import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../api";
import ProductCard from "./ProductCard";

// Homepage strip built from real-sales Best Seller badges; hidden when none earned.
export default function BestSellersStrip() {
  const [list, setList] = useState([]);
  useEffect(() => {
    Promise.all([api.get("/products/badges"), api.get("/products")])
      .then(([b, p]) => {
        const all = Array.isArray(p.data) ? p.data : p.data.products || [];
        setList(all.filter((x) => (b.data[x.slug] || []).includes("best_seller")).slice(0, 4));
      })
      .catch(() => setList([]));
  }, []);
  if (!list.length) return null;

  return (
    <section data-testid="best-sellers-strip" className="max-w-7xl mx-auto px-6 py-20">
      <div className="flex items-end justify-between mb-10">
        <div>
          <div className="overline">BEST SELLERS</div>
          <h2 className="font-heading text-3xl sm:text-4xl mt-3">What researchers are ordering.</h2>
        </div>
        <Link to="/shop" className="hidden sm:inline-flex items-center gap-2 text-xs font-mono-tech uppercase tracking-[0.2em] text-[#00C3FF] hover:text-white">
          Shop All <ArrowRight size={12} />
        </Link>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
        {list.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    </section>
  );
}
